import { DataTable } from '@pihealth/common-ui-library';
import React, { useEffect, useState } from 'react';
import staticData from '../../../resources/static.json';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { setSelectedRowData, setChckListCMPArr } from 'src/store/sqCheckList';
import { useGetAllSQChecklistsMutation, useGetAllPILSQChecklistsMutation } from 'src/services/SqChecklist';
import { useUtil } from 'src/components/hooks/useUtil';
import { archLevel } from 'src/data/config';
import { useSelectedAppInfo } from 'src/util/SelectedAppInfo';
import { useFieldTranslation } from 'src/components/fields/useFieldTranslation';
import VersionHistory from 'src/components/common/VersionHistory';
import { useUser } from 'src/components/hooks/useUser';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
import { Box } from '@mui/material';

const SQChecklistListView: React.FunctionComponent<any> = () => {
  const { userPreferedDateFormat, getPreferredDateTimeInLocal } = usePreferedDateFormat();
  const { preferences } = useUser();
  const { handleError } = useUtil();
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector((state: any) => state.site.selectedCountry);
  const selectedSite = useAppSelector((state: any) => state.site.selectedSite);
  const { selectedAppSection } = useSelectedAppInfo();
  const { applicationModuleSection } = useFieldTranslation();
  const dispatch = useAppDispatch();
  const [rows, setRows] = useState<any>([]);
  const [headerTitle, setHedertitle] = useState('');
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [docId, setDocId] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [rowsCount, setRowsCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [filterObject, setFilterObject] = useState<any>();

  const rowClick = (rowData: any) => {
    dispatch(setSelectedRowData(rowData));
    dispatch(setChckListCMPArr('sqchecklistpage'));
  };
  const versionClick = (versionData: any) => {
    setHedertitle(versionData.visit_name);
    setDocId(versionData.tp_document_id);
    setShowVersionHistory(true);
  };
  const actions = {
    visit_name: (data: any) => {
      rowClick(data);
    },
    major_version: (data: any) => {
      versionClick(data);
    }
  };
  const [
    getAllSQChecklists,
    {
      data: getAllsqChecklistData,
      error: getAllsqChecklistError,
      isError: getAllsqChecklistIsError,
      isLoading: getAllsqChecklistIsLoading
    }
  ] = useGetAllSQChecklistsMutation();
  const [
    getAllPILSQChecklists,
    {
      data: getAllPILsqChecklistData,
      error: getAllPILsqChecklistError,
      isError: getAllPILsqChecklistIsError,
      isLoading: getAllPILsqChecklistIsLoading
    }
  ] = useGetAllPILSQChecklistsMutation();
  const getSQChecklistsfunc = (from: number, size: number) => {
    archLevel == 'sponsor'
      ? getAllSQChecklists({
          data: filterObject,
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME,
          application_section: selectedAppSection,
          application_module_section: applicationModuleSection.sqChecklist,
          from,
          size
        })
      : getAllPILSQChecklists({
          data: filterObject,
          site_id: selectedSite,
          study_id: studyId,
          country: selectedCountry,
          application: process.env.REACT_APP_NAME_TEMP,
          application_section: selectedAppSection,
          application_module_section: applicationModuleSection.sqChecklist,
          from,
          size
        });
  };

  useEffect(() => {
    if (
      (!getAllsqChecklistIsLoading || !getAllPILsqChecklistIsLoading) &&
      (pageSize === 10 || pageSize === 20 || pageSize === 30)
    ) {
      if (pageNumber * pageSize > rowsCount - 1) {
        setPageNumber(0);
        getSQChecklistsfunc(0, pageSize);
      } else {
        getSQChecklistsfunc(pageNumber * pageSize, pageSize);
      }
    }
  }, [selectedSite, studyId, selectedCountry, pageNumber, pageSize, filterObject]);
  useEffect(() => {
    if (getAllsqChecklistData) {
      setRowsCount(getAllsqChecklistData?.record_count);
      setRows(
        getAllsqChecklistData?.selected_data?.map((item: any) => {
          return {
            ...item,
            start_date: getPreferredDateTimeInLocal(item.start_date),
            updated_on: getPreferredDateTimeInLocal(item.updated_on),
            major_version: Number(item.major_version).toFixed(1).toString()
          };
        })
      );
    }
    if (getAllPILsqChecklistData) {
      setRowsCount(getAllPILsqChecklistData?.record_count);
      setRows(
        getAllPILsqChecklistData?.selected_data?.map((item: any) => {
          return {
            ...item,
            start_date: getPreferredDateTimeInLocal(item.start_date),
            updated_on: getPreferredDateTimeInLocal(item.updated_on),
            major_version: Number(item.major_version).toFixed(1).toString()
          };
        })
      );
    }
  }, [getAllsqChecklistData, getAllPILsqChecklistData]);

  useEffect(() => {
    if (getAllsqChecklistIsError) {
      handleError(getAllsqChecklistError);
      setRows([]);
      setRowsCount(0);
      setPageNumber(0);
    }
    if (getAllPILsqChecklistIsError) {
      handleError(getAllPILsqChecklistError);
      setRows([]);
      setRowsCount(0);
      setPageNumber(0);
    }
  }, [getAllsqChecklistIsError, getAllPILsqChecklistIsError]);
  const filterValues = (data: any) => {
    setFilterObject(data);
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${staticData.sqChecklistView.file_export_name} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  const dataTableProps = {
    filterMode: 'server'
  };
  return (
    <>
      <Box sx={{ '& .MuiDataGrid-cell .MuiLink-underlineAlways': { cursor: 'pointer' } }}>
        <DataTable
          rows={rows}
          columns={staticData.sqChecklistView.dataTablecolumns}
          datePreference={preferences?.date_format ? preferences?.date_format : 'MM/dd/yyyy'}
          actions={actions}
          loading={getAllsqChecklistIsLoading}
          showDateAndTime
          paging
          pageSize={pageSize}
          setPageSize={setPageSize}
          rowsCount={rowsCount}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          paginationMode="server"
          hasDefinedDataGridToolbarExport
          definedGridToolbarExport={definedCustomDatGridExport}
          filterValues={(data: any) => filterValues(data)}
          dataTableProps={dataTableProps}         
        />
      </Box>
      {showVersionHistory ? (
        <VersionHistory
          openVersoinHistory={showVersionHistory}
          setOpenVersoinHistory={setShowVersionHistory}
          title={headerTitle}
          documentId={docId}
          auditModuleSection={'SQ CHECKLIST'}
        />
      ) : (
        ''
      )}
    </>
  );
};
export default SQChecklistListView;
